import labels from "emun.products/lists/_labels";
import templateUrl from "emun.products/lists/product-list-print.htm";
import productConfig from "emun.products/product.config";
import basicController from "servicestack/basic.controller.properties";
import ServiceBus from "servicestack/service-bus";
import open from "webmodals/open";

export const itemsPerPageArray = productConfig.printListItemsPerPageArray;

export const sortOptions = {
  "strProductID ASC": "Product # ASC",
  "strProductID DESC": "Product # DESC",
  "memDescription ASC": "Product Name ASC",
  "memDescription DESC": "Product Name DESC",
  "intCatalogPage ASC": "Featured ASC",
  "intCatalogPage DESC": "Featured DESC",
  "ListPosition ASC": "List Position ASC",
  "ListPosition DESC": "List Position DESC",
  "curSalesPrice ASC": "Price ASC",
  "curSalesPrice DESC": "Price DESC",
  "strCategory ASC": "Category ASC",
  "strCategory DESC": "Category DESC",
  "strVendorID ASC": "Vendor ASC",
  "strVendorID DESC": "Vendor DESC",
  "strStatus ASC": "Status ASC",
  "strStatus DESC": "Status DESC",
};

export default (options) =>
  open({
    size: options.size || "md",
    templateUrl: options.templateUrl || templateUrl,
    bindToController: true,
    controllerAs: "$ctrl",
    controller() {
      const $ctrl = this;
      basicController($ctrl);
      //console.debug("product-list-print", { options, $ctrl });
      $ctrl.format = "STD";
      $ctrl.title = options.title || "List Printout";
      $ctrl.subTitle = options.subTitle;
      $ctrl.bus = new ServiceBus();
      $ctrl.unique = Math.round(Math.random() * 100);
      $ctrl.config = productConfig;
      //console.info("$ctrl.config", $ctrl.config);
      $ctrl.request = Object.assign(
        {
          orderBy: "strProductID",
          itemsPerPage: "4",
          hidePrice: false,
          includeBarcode: false,
          includeInactive: false,
          pricelist: labels.defaultPriceList || "",
          active: true,
          uid: $ctrl.unique,
        },
        options.request
      );
      // console.debug("product-list-print.request", $ctrl.request);
      $ctrl.labels = labels;
      $ctrl.itemsPerPageArray = itemsPerPageArray;
      $ctrl.sortOptions = productConfig.listSortOptions || sortOptions;
      $ctrl.pricelist = labels.defaultPriceList || $ctrl.pricelist || "";
      $ctrl.changeFormat = () => {
        const $ctrl = this;
        if ($ctrl.format === "SPEC") {
          $ctrl.request.itemsPerPage = "1";
        }
      };
      $ctrl.getUrl = () => {
        if ($ctrl.format === "SPEC") {
          return $ctrl.$appConfig.resolveServiceUrl(
            `ProductDetailSheet?${Object.keys($ctrl.request)
              .map((key) => key + "=" + $ctrl.request[key])
              .join("&")}`
          );
        } else if ($ctrl.format === "HangTag") {
          return `${$ctrl.$appConfig.serviceUrl}HangTag?${Object.keys(
            $ctrl.request
          )
            .map((key) => key + "=" + $ctrl.request[key])
            .join("&")}`;
        } else {
          if ($ctrl.request.includeInactive) {
            delete $ctrl.request.active;
          } else {
            $ctrl.request.active = true;
          }

          return $ctrl.$appConfig.resolveServiceUrl(
            `ProductExport?${Object.keys($ctrl.request)
              .map((key) => key + "=" + $ctrl.request[key])
              .join("&")}`
          );
        }
      };
      $ctrl.bus
        .read("QueryPermissions.json", {
          GroupName: "Pricelists",
          CodeNotIn: "AllPricelists",
          orderBy: "Name",
        })
        .then((res) => ($ctrl.pricelists = res.data.results));
      $ctrl.bus
        .read("QueryProductOptionGrades.json")
        .then((res) => ($ctrl.grades = res.data.results));
      $ctrl.bus
        .read(`QueryProducts.json?ListId=${$ctrl.request.listId}`)
        .then(
          (res) =>
            ($ctrl.productIds = res.data.results.map((obj) => obj.id).join(","))
        );
    },
  }).result;
